import React from 'react';
import { CarsConstatns, ContentConstants } from '../Constants';
import { Facet } from '../SearchModels';
import CheckListFilter from './CheckListFilter';
import ColorFilter from './ColorFilter';
import RangeFilter from './RangeFilter';
import i18next from 'i18next';
interface FilterSelectorProps {
  queryString?: string;
  facet: Facet;
  loading?: boolean;
  initialFacets?: Facet[];
  urlSearchParams?: URLSearchParams;
  onFilterUpdate: (query: string) => void;
}

const FilterSelector = ({
  queryString,
  facet,
  loading,
  initialFacets,
  urlSearchParams,
  onFilterUpdate,
}: FilterSelectorProps) => {
  switch (facet.id) {
    case CarsConstatns.MANUFACTURER:
    case CarsConstatns.MODEL_SERIES:
    case CarsConstatns.FUEL_TYPE:
    case CarsConstatns.GEARBOX_TYPE:
    case CarsConstatns.BRANCH:
    case CarsConstatns.ENVIRONMENT_CLASS:
    case CarsConstatns.SEGMENT:
    case CarsConstatns.DRIVING_WHEEL:
    case ContentConstants.PAGE_TYPE:
      return <CheckListFilter facet={facet} loading={loading} onFilterUpdate={onFilterUpdate} />;
    case CarsConstatns.COLOR:
      return <ColorFilter facet={facet} loading={loading} onFilterUpdate={onFilterUpdate} />;
    case CarsConstatns.PRICE:
      return (
        <RangeFilter
          queryString={queryString}
          facet={facet}
          loading={loading}
          urlSearchParams={urlSearchParams}
          initialFacets={initialFacets}
          onFilterUpdate={onFilterUpdate}
          unit={i18next.t('currency.default') || ''}
          formatValues
        />
      );
    case CarsConstatns.LEASING_PRICE:
      return (
        <RangeFilter
          queryString={queryString}
          facet={facet}
          loading={loading}
          urlSearchParams={urlSearchParams}
          initialFacets={initialFacets}
          onFilterUpdate={onFilterUpdate}
          unit={i18next.t('currency.monthly') || ''}
          formatValues
        />
      );
    case CarsConstatns.ODOMETER_VALUE_AS_KM:
      return (
        <RangeFilter
          queryString={queryString}
          facet={facet}
          loading={loading}
          urlSearchParams={urlSearchParams}
          initialFacets={initialFacets}
          onFilterUpdate={onFilterUpdate}
          unit={i18next.t('odometer.Kilometer') || ''}
          formatValues
        />
      );
    case CarsConstatns.MILEAGE:
      return (
        <RangeFilter
          queryString={queryString}
          facet={facet}
          loading={loading}
          urlSearchParams={urlSearchParams}
          initialFacets={initialFacets}
          onFilterUpdate={onFilterUpdate}
          unit={i18next.t('odometer.ScandinavianMile') || ''}
          formatValues
        />
      );
    case CarsConstatns.MODEL_YEAR:
      return (
        <RangeFilter
          queryString={queryString}
          facet={facet}
          loading={loading}
          urlSearchParams={urlSearchParams}
          initialFacets={initialFacets}
          onFilterUpdate={onFilterUpdate}
        />
      );
    default:
      return null;
  }
};

export default FilterSelector;
